export default __webpack_public_path__ + "static/media/photo--sm--chris-1.01a9b8e9.jpg";